import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=510f4042&"
import script from "./MediaUpload.vue?vue&type=script&lang=js&"
export * from "./MediaUpload.vue?vue&type=script&lang=js&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/MediaUpload.vue
// module id = null
// module chunks = 